import React, { useContext, useEffect, useState } from 'react';
import { OrderContext } from '../contexts/OrderContext'
import { isoToBrDate } from '../utils';
import './Informacoes.css';
import { orderIDField } from '../contants'
import * as zendesk from '../api/zendesk'
import Loading from '../components/Loading';

export default function Informacoes() {
    const order = useContext(OrderContext).order
    const [ids, setIds] = useState(null);
    const [zenUrl, setZenUrl] = useState("#");
    const [loaded, setLoaded] = useState(false)

    async function getTicketsByOrderIdFieldValue(orderIDValue) {
        return await zendesk.getTicketsByFieldValue(orderIDField, orderIDValue)
    }

    async function getIdTicketsOrder() {
        let list = []
        const orderId = order.orderId
        const allTickets = await getTicketsByOrderIdFieldValue(orderId)
        localStorage.setItem('order', orderId)

        for (const ticket of allTickets) {
            list.push(ticket.id)
        }

        setIds(list)
    }

    function renderIds() {
        if (ids.length === 0)
            return <small>Não existem tickets associados a este pedido</small>

        return ids.map(id => (
            <span className="idTicket" >
                <span className="xablau">Ticket</span>
                <a className="link-ticket-style"
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: '#000000' }}
                    href={`${zenUrl}/agent/tickets/${id}`}
                >
                    #{id} &nbsp;
                </a>
            </span>
        ))
    }

    useEffect(() => {
        zendesk.getZendeskUrl().then(setZenUrl)

        if (ids === null || ids.length === 0)
            getIdTicketsOrder()

        setLoaded(true)
    }, [ids])

    return (
        <section id="informations-pedido">
            <div className="info">
                <h3>Informações do pedido</h3>
                <div className="informations">
                    <p>Order ID: {order?.orderId}</p>
                    <p>Transportadora: {order?.shippingData.logisticsInfo[0].deliveryIds[0].courierName}</p>
                    <p>Tipo de pagamento: {order?.paymentData.transactions[0].payments[0].paymentSystemName}</p>
                    <p>Sequence: {order?.sequence}</p>
                    <p>Data:   {isoToBrDate(order?.creationDate)}</p>

                </div>
            </div>

            <div className="order">
                <h3>Cliente</h3>
                <div className="informations">
                    <p>Nome:  {order?.clientProfileData.firstName}&nbsp;{order?.clientProfileData.lastName}</p>
                    <p>Telefone: {order?.clientProfileData.phone}</p>
                    <p>CPF: {order?.clientProfileData.document}</p>
                    <p>E-mail: {order?.clientProfileData.email}</p>
                </div>
            </div>

            <div id="ticket" className="ticket">
                <div className="cabecalho-ticket">
                    <p>Tickets sobre os Pedidos</p>
                </div>
                <div className="organization-ticket">
                    {ids ?
                        <div className="tickets-order">
                            <p>{loaded ? renderIds() : ""}</p>
                        </div> : <Loading />
                    }
                </div>
            </div>
        </section>
    )
}